module.exports = __webpack_public_path__ + "img/czb.cc7bab93.png";